<template>
  <vx-card v-if="dates && filters">
    <div id="pdf"></div>
    <vs-row>
      <vs-col vs-w="12">
        <div class="flex flex-end">

          <template v-if="dates && dateValue!==null">
          <div class="mr-3">
            <vs-select v-model="dateValue" @change="onDateChange">
              <vs-select-item v-for="val in dates" :key="val.value" :text="val.label" :value="val.value"></vs-select-item>
            </vs-select>
          </div>
          </template>

          <feather-icon class="filter-hover-button" @click="onDownload()" icon="DownloadIcon"
                        svgClasses="h-8 w-8 mb-1 mr-3 stroke-current text-primary"/>

          <feather-icon class="filter-hover-button" @click="onRefresh()" icon="RefreshCwIcon"
                        svgClasses="h-8 w-8 mb-1 mr-3 stroke-current text-primary"/>

          <feather-icon class="filter-hover-button" @click="onShowFilters()" icon="FilterIcon"
                        svgClasses="h-8 w-8 mb-1 mr-3 stroke-current text-primary"/>
        </div>
        <vs-row>
          <vs-col :vs-w="showFiltersTransition? 10:12" class="p-2">
            <vs-tabs alignment="fixed">
              <vs-tab label="Registrations" v-if="analysisResource.$hasLink('registrations')">
                <analysis-registrations ref="print" :bus="bus" :resource="analysisResource" :filters="filterValues" :date="dateValue"/>
              </vs-tab>
              <vs-tab label="Demographics" v-if="analysisResource.$hasLink('demographics')">
                <analysis-demographics ref="print" :bus="bus" :resource="analysisResource" :filters="filterValues" :date="dateValue"/>
              </vs-tab>
              <vs-tab label="Mental Health" v-if="analysisResource.$hasLink('mental_health')">
                <analysis-mental-health ref="print" :bus="bus" :resource="analysisResource" :filters="filterValues" :date="dateValue"/>
              </vs-tab>
              <vs-tab label="Referrals" v-if="analysisResource.$hasLink('referrals')">
                <analysis-referrals ref="print" :bus="bus" :resource="analysisResource" :filters="filterValues" :date="dateValue"/>
              </vs-tab>
            </vs-tabs>
          </vs-col>
          <vs-col :vs-w="2" class="p-2" style="margin-top:60px;">
            <sm-hateoas-filters ref="onFilter"
                                v-if="filters"
                                v-show="showFiltersTransition"
                                @update-transition="onUpdateFilterTransition"
                                :filter-resource="filters" @filters-change="onFilterChange"></sm-hateoas-filters>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>
  </vx-card>
</template>
<script>
import {ResourceImpl} from 'hal-client';
import SmHateoasFilters from '../../../components/starling/sm-hateoas-filters/sm-hateoas-filters';
import AnalysisRegistrations from './registrations/analysis-registrations';
import AnalysisDemographics from './demographics/analysis-demographics';
import AnalysisMentalHealth from './mental_health/analysis-mental-health';
import AnalysisReferrals from './referrals/analysis-referrals';
import Vue from 'vue';
import * as moment from 'moment';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

export default {
  components: {
    AnalysisReferrals,
    SmHateoasFilters,
    AnalysisMentalHealth,
    AnalysisDemographics,
    AnalysisRegistrations
  },
  props: {
    analysisResource: ResourceImpl
  },
  data () {
    return {
      filters: null,
      filterValues: null,
      showFiltersTransition: false,
      dates: null,
      dateValue: null,
      bus: new Vue()
    };
  },
  computed: {
    developmentEnv () {
      return process.env.NODE_ENV !== 'production';
    }
  },
  mounted () {
    this.analysisResource.$request().$get('available-dates').then(dates => {
      this.dates = dates.terms.map(term => {
        return {
          label: term.label === 'CURRENT' ? this.$t('reports.global.date.CURRENT') : moment(term.label).format('MMMM YYYY'),
          value: term.value
        };
      });

      if (!this.dateValue && this.dates.length) {
        this.dateValue = this.dates[0].value;
      }
    });
    this.analysisResource.$request().$get('filters').then(res => {
      this.filters = res;
    });
  },
  methods: {
    onDateChange (date) {
      this.dateValue = date;
      this.$nextTick(() => {
        this.onRefresh();
      });
    },
    onFilterChange (filterValues) {
      this.filterValues = filterValues;
      this.$nextTick(() => {
        this.onRefresh();
      });
    },
    onUpdateFilterTransition () {
      this.showFiltersTransition = !this.showFiltersTransition;
    },
    onShowFilters () {
      this.$refs.onFilter.onShowFilters();
    },
    onRefresh () {
      this.bus.$emit('refresh');
    },
    onDownload () {
      html2canvas(this.$refs.print.$el, {
        imageTimeout: 5000,
        useCORS: true
      }).then(canvas => {
        const resizedCanvas = document.createElement('canvas');
        const resizedContext = resizedCanvas.getContext('2d');

        resizedCanvas.height = canvas.height / 2;
        resizedCanvas.width = canvas.width / 2;

        resizedContext.drawImage(canvas, 0, 0, resizedCanvas.width, resizedCanvas.height);

        document.getElementById('pdf').appendChild(resizedCanvas);

        const img = resizedCanvas.toDataURL('image/png');

        const maxWidth = 278; // Max width for the image
        const maxHeight = 213;    // Max height for the image
        let ratio = 0;  // Used for aspect ratio
        let width = canvas.width;    // Current image width
        let height = canvas.height;  // Current image height

        // Check if the current width is larger than the max
        if (width > maxWidth) {
          ratio = maxWidth / width;   // get ratio for scaling image
          height = height * ratio;    // Reset height to match scaled image
          width = width * ratio;    // Reset width to match scaled image
        }

        // Check if current height is larger than max
        if (height > maxHeight) {
          ratio = maxHeight / height; // get ratio for scaling image
          width = width * ratio;    // Reset width to match scaled image
          height = height * ratio;    // Reset height to match scaled image
        }

        const pdf = new jsPDF('l', 'mm', 'letter');
        pdf.addImage(img, 'JPEG', (maxWidth - width) / 2, (maxHeight - height) / 2, width, height);
        pdf.save('analysis-export.pdf');
        document.getElementById('pdf').innerHTML = '';
      });
    }
  }
};
</script>
